var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"text-h3"},[_vm._v("Pricing Plans")]),_c('div',{staticClass:"mb-4 caption"},[(_vm.loading)?_c('div',[_vm._v("Loading...")]):_c('div',[_c('div',[_vm._v(_vm._s(_vm.plans.length)+" results found")]),_c('PricingPlanList',{attrs:{"plans":_vm.plans}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }